import { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "../guards/ProtectedRoute";
import { LAYOUT_IDENTIFIERS, MODULE_PATHS } from "../../utils/moduleConfig";

const MainLayout       = lazy(() => import("../../layouts/MainLayout/MainLayout"));
const Layout           = lazy(() => import("../../Modules/GoalsManager/Layout/Layout"));
const GoalManagerDashboard = lazy(() => import("../../Modules/GoalsManager/Page/GoalManagerDashboard"));
const GoalsPage        = lazy(() => import("../../Modules/GoalsManager/Page/GoalsPage"));
const GoalsDetails     = lazy(() => import("../../Modules/GoalsManager/Page/GoalsDetails"));
const KeyResult        = lazy(() => import("../../Modules/GoalsManager/Page/KeyResult"));
const GoalPlansPage    = lazy(() => import("../../Modules/GoalsManager/Plan/Page/GoalPlansPage"));
const GoalPlanBuilderPage = lazy(() => import("../../Modules/GoalsManager/Plan/Page/GoalPlanBuilderPage"));
const GoalPlanDetailPage = lazy(() => import("../../Modules/GoalsManager/Plan/Page/GoalPlanDetailPage"));

const goalManagerRoutes = {
  path: MODULE_PATHS.goalManager,
  element: (
    <ProtectedRoute>
      <MainLayout identifier={LAYOUT_IDENTIFIERS.goalManager} />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="dashboard" replace />,
    },
    // ── Goals dashboard ───────────────────────────────────────────────────
    {
      path: "dashboard",
      element: <GoalManagerDashboard />,
    },
    // ── Goals list (index) ────────────────────────────────────────────────
    {
      path: "goals",
      element: <GoalsPage />
    },
    // ── Objective detail + KR detail ──────────────────────────────────────
    {
      path: "goals/:goalId",
      element: <Layout />,
      children: [
        { index: true, element: <GoalsDetails /> },
        { path: ":krId", element: <KeyResult /> },
      ],
    },

    {
      path: "plan",
      element: <GoalPlansPage />,
    },
    {
      path: "plan/new",
      element: <GoalPlanBuilderPage />,
    },
    {
      path: "plan/:planId",
      element: <GoalPlanDetailPage />,
    },
  ],
};

export default goalManagerRoutes;
